import { ReduxStore } from 'store/types';

function forgotPasswordEmail(state: ReduxStore): string {
  return state.auth.forgotPassword.config.email;
}

export default forgotPasswordEmail;
